import React from 'react';
import { createRoot } from 'react-dom/client';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import App from './App';

defineCustomElements(window);

const virtualKeyboard = (navigator as Navigator & {
  virtualKeyboard?: { overlaysContent: boolean };
}).virtualKeyboard;

try {
  if (virtualKeyboard) {
    virtualKeyboard.overlaysContent = true;
  }
} catch {
  // Some browsers expose partial VirtualKeyboard implementations.
}

createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
